import React, { FC } from 'react';

import { BaseWorksheetFormElement, WorksheetFormElementRenderProps } from '@packages/ui/worksheet';

export const WorksheetFormElement: FC<WorksheetFormElementRenderProps> = ({ ...props }) => {
    return <BaseWorksheetFormElement {...props} />;
};
